import React from "react";
import { CheckIcon, GiftIcon, ShoppingCartIcon } from "lucide-react";
import { bonuses } from "../data/bonuses";
import { images, product } from "../data/product";
import { BundleGallery } from "./BundleGallery";
import { CategoryGrid } from "./ui/CategoryGrid";
import { CtaButton } from "./ui/CtaButton";
import { ImageSlot } from "./ui/ImageSlot";
import { SectionHeading } from "./ui/SectionHeading";
type BundleOfferProps = {
  id?: string;
  title: React.ReactNode;
  subtitle: string;
  withGallery?: boolean;
};
export function BundleOffer({
  id,
  title,
  subtitle,
  withGallery = false
}: BundleOfferProps) {
  return <section id={id} className="scroll-mt-16 bg-blush px-4 py-14 sm:px-6 sm:py-20" data-id="element-31" data-mp="em2zo7jhh3vg">
      <SectionHeading title={title} subtitle={subtitle} data-id="element-32" data-mp="9tia5i7m1cxq" />
      <div className="mx-auto mt-8 grid max-w-6xl grid-cols-[minmax(0,1fr)] gap-8 rounded-[32px] border border-line bg-cream p-4 shadow-[0_20px_44px_-30px_rgba(86,18,54,0.55)] sm:p-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-12 lg:p-10" data-id="element-33" data-mp="3iad4uae97r0q">
        <div className="w-full min-w-0 lg:sticky lg:top-24 lg:self-start" data-id="element-34" data-mp="14hqf4rl1saoe">
          {withGallery ? <BundleGallery data-id="element-35" data-mp="19ga12rzn5mgr" /> : <ImageSlot src={images.heroBundle} alt="Il bundle completo con ricette e bonus" placeholderLabel="Mockup del bundle" className="aspect-[4/3] w-full rounded-[22px]" data-id="element-36" data-mp="1e8bam65fcz33" />}
        </div>

        <div className="mx-auto w-full min-w-0 max-w-[480px] px-1 sm:px-0 lg:self-center" data-id="element-37" data-mp="llgqxbgfm3qo">
          <h3 className="text-center font-serif text-[28px] font-semibold leading-[1.15] text-wine sm:text-[34px]" data-id="element-38" data-mp="qj8syyasj68l">
            {product.name}: bundle di {product.recipesText} ricette in {product.volumesCount} volumi
          </h3>

          <div className="mt-6" data-id="element-39" data-mp="26wz2ikkoimpm">
            <CategoryGrid data-id="element-40" data-mp="26xryqrm0htti" />
          </div>

          <p className="mt-7 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center text-[15px] text-ink" data-id="element-41" data-mp="26z342vv3v9mq">
            <span className="rounded-lg bg-chip px-2.5 py-1 font-semibold text-wine" data-id="element-42" data-mp="bttxtchjrxrq">
              {product.bonusCount} bonus gratuiti
            </span>
            <span data-id="element-43" data-mp="6u7ld59jmljz">inclusi nel bundle:</span>
          </p>
          <ul className="mt-3 space-y-2.5" data-id="element-44" data-mp="kv0ilxr8buqs">
            {bonuses.map(b => <li key={b.number} className="flex items-center gap-3 rounded-2xl bg-chip px-4 py-3.5" data-id="element-45" data-mp="gsx573l02g2v">
                <GiftIcon className="h-[18px] w-[18px] shrink-0 text-rose" strokeWidth={1.5} aria-hidden="true" data-id="element-46" data-mp="3p8qbyqpj4d6q" />
                <span className="text-[15px] font-semibold leading-snug text-wine" data-id="element-47" data-mp="3ka5kbfocf1tw">{b.name}</span>
              </li>)}
          </ul>

          <div className="mt-8 text-center" data-id="element-48" data-mp="1x7if37zpyx3">
            <p className="font-serif text-[48px] font-semibold leading-none text-wine sm:text-[56px]" data-id="element-49" data-mp="3tak6eh94skyg">{product.price}</p>
            <p className="mt-2 text-sm text-ink" data-id="element-50" data-mp="35jxzitav56q1">Pagamento unico, nessun abbonamento</p>
            <div className="mt-6" data-id="element-51" data-mp="31jnvvnajmsec">
              <CtaButton icon={<ShoppingCartIcon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-53" data-mp="31h1obnnnkcw4" />} className="sm:w-full" data-id="element-52" data-mp="31imivd9yvvtz">
                Ottieni il bundle e tutti e 5 i bonus
              </CtaButton>
            </div>
            <p className="mt-4 flex items-center justify-center gap-1.5 text-sm text-ink" data-id="element-54" data-mp="2w7qvjwfbaghz">
              <CheckIcon className="h-4 w-4 text-rose" aria-hidden="true" data-id="element-55" data-mp="2hex4reulady0" />
              Pagamento sicuro e accesso immediato
            </p>
          </div>
        </div>
      </div>
    </section>;
}